export default __webpack_public_path__ + "static/media/bondly-wbnb.aae67d1e.svg";